import { catchError, tap } from 'rxjs/operators';
import { noop, Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as env, environment } from '../environments/environment';
import { IWallet, IMovements, IWallatesAdmin, TransactionLogResponse } from '../models/interfaces/wallet.model';
import { IResponse } from '../models/interfaces/response.model';
import { Order } from '../models/order';
import { SideMenuService } from './../../admin/src/app/components/layout/side-menu/services/side-menu.service';
@Injectable({
  providedIn: 'root',
})
export class WalletService {
  apiURL = `${env.apiUrl}wallets/`;
  apiTransactionsURL = `${env.apiUrl}wallet-transactions`;

  constructor(
    private http: HttpClient,
    private sideMenuService: SideMenuService
  ) {
  }

  createWallet(wallet: IWallet | any): Observable<IWallet> {
    return this.http
      .post<IWallet>(this.apiURL, wallet)
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  /*=================================ADMIN============================================*/
  adminTopUp(payload: {}, walletId: string): Observable<IWallet> {
    return this.http.post<IWallet>(
      `${this.apiURL}admin-top-up/${walletId}`, payload,
      // { amount: amount }
    );
  }

  getWallets(param: {} = {}): Observable<IWallatesAdmin> {
    const params = new HttpParams({ fromObject: param });
    return this.http.get<IWallatesAdmin>(
      `${this.apiURL}admin-wallets?${params.toString()}`
    );
  }

  getwalletById(walletId: string): Observable<IWallet> {
    return this.http.get<IWallet>(`${this.apiURL}admin-wallets/${walletId}`);
  }

  getMovements(walletId: string, param: {} = {}): Observable<IResponse<IMovements>> {
    const params = new HttpParams({ fromObject: param });
    return this.http.get<IResponse<IMovements>>(
      `${this.apiURL}admin-wallets/${walletId}/movments?${params}`
    );
  }

  changeWalletSettings(id: string, newSettings: IWalletSetting): Observable<any> {
    return this.http.patch(`${environment.apiUrl}wallets/${id}/settings`, newSettings);
  }

  getTransactionLogs(param: {}): Observable<TransactionLogResponse> {
    const params = new HttpParams({ fromObject: param });
    return this.http.get<TransactionLogResponse>(
      `${this.apiTransactionsURL}?${params.toString()}`
    );
  }

  /*=================================USER============================================*/
  getUserWallets(): Observable<IWallet[]> {
    return this.http.get<IWallet[]>(`${this.apiURL}user-wallets`);
  }
  getUserWalletById(walletId: string): Observable<IWallet> {
    return this.http.get<IWallet>(`${this.apiURL}user-wallets/${walletId}`);
  }
  getUserMovements(walletId: string, param: {} = {}): Observable<IResponse<IWallet>> {
    const params = new HttpParams({ fromObject: param });
    return this.http.get<IResponse<IWallet>>(
      `${this.apiURL}user-top-up-orders?currency=${walletId}&${params}`
    );
  }

  setDefaultWallets(walletId: string): Observable<any> {
    return this.http.patch<any>(
      `${this.apiURL}user-wallets/${walletId}/set-default`, {}
    );
  }

  /*=================================TopUpList===========================================*/
  getTopUp(params: string = ''): Observable<any> {
    return this.http.get<any>(`${this.apiURL}admin-top-up-order?${params}`);
  }

  countTopUps(queryParam = ''): Observable<any> {
    return this.http.get<any>(`${this.apiURL}admin-top-up-order/status-count`);
  }

  getCountTopUps() {
    this.countTopUps().pipe(tap(
      counts => {
        this.sideMenuService.topUpsCount_BS.next(counts)
      }
    )).subscribe(noop,)
  }


  getOneTopUp(Id: string): Observable<any> {
    return this.http.get<any>(`${this.apiURL}admin-top-up-order/${Id}`);
  }

  updatetopUp(topUp: any): Observable<any> {
    return this.http.patch<any>(`${this.apiURL}admin-top-up-order/${topUp._id}`, topUp);
  }

  updateTopUsStatus(topupId: any, status: any): Observable<any> {
    return this.http.patch<any>(`${this.apiURL}admin-top-up-order/${topupId}/status`, status);
  }

  // /admin-top-up-order/66f17e2561692e74a7c73a8e/status
  deletetopUp(topUpId: string): Observable<any> {
    return this.http.delete<any>(`${this.apiURL}admin-top-up-order/${topUpId}`);
  }
}


interface IWalletSetting {
  isVisible: boolean;
  allowDeposits: boolean;
  allowPayments: boolean;
}
